// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__3MxRa","header":"ReportDetails_header__1SLbG","title":"ReportDetails_title__1kN6-","left":"ReportDetails_left__1rCMw"};